import { uniq } from "lodash";
import { RaceWagerType } from "@tvg/ts-types/Race";
import { WagerTypeCodesEnum } from "@tvg/ts-types/Wager";
import { Dispatch } from "redux";
import { setSelectionRequest } from "@tvg/desktop-bet/src/store/actions";
import { RunnerBI } from "../../../../../hooks/useGetRunnerFromBI";

export const filterSelectAllLabels = (
  textLabels: Array<string>,
  wagerType: RaceWagerType
) => {
  let labels;
  const { isKey, isBox, isWheel } = wagerType;
  const isQuinellaOmniTrio =
    wagerType.type.code === WagerTypeCodesEnum.QUINELLA ||
    wagerType.type.code === WagerTypeCodesEnum.OMNI ||
    wagerType.type.code === WagerTypeCodesEnum.TRIO;
  const isTrioWheel = wagerType.type.code === WagerTypeCodesEnum.TRIO_WHEEL;

  if (isBox || isWheel || isKey || isQuinellaOmniTrio) {
    labels = textLabels.map((label: string) => label.concat(" all"));
  } else {
    labels = textLabels;
  }
  if (isKey) {
    return labels.filter((label) => label !== "Key all");
  }
  if (isTrioWheel) {
    return labels.filter((label) => label !== "Primary all");
  }
  return labels;
};

export const isAllSelected = (
  selections: string[][],
  wagerType: RaceWagerType,
  numWagerableRunners?: string
) => {
  const { isKey } = wagerType;
  const isTrioWheel = wagerType.type.code === WagerTypeCodesEnum.TRIO_WHEEL;
  const isAllSelectedArray: boolean[] = [];
  const wagerableRunners: number = Number(numWagerableRunners);

  if (isTrioWheel) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    selections[1] && selections[1].length === wagerableRunners
      ? isAllSelectedArray.push(true)
      : isAllSelectedArray.push(false);
  } else if (isKey) {
    const wagerableNumComparison = selections[0][0]
      ? wagerableRunners - 1
      : wagerableRunners;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    selections[1] && selections[1].length === wagerableNumComparison
      ? isAllSelectedArray.push(true)
      : isAllSelectedArray.push(false);
  } else {
    for (let i = 0; i < selections.length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      selections[i as number].length === wagerableRunners
        ? isAllSelectedArray.push(true)
        : isAllSelectedArray.push(false);
    }
  }

  return isAllSelectedArray;
};

export const getPosition = (index: number, wagerType: RaceWagerType) => {
  const { isKey } = wagerType;
  const isTrioWheel = wagerType.type.code === WagerTypeCodesEnum.TRIO_WHEEL;
  if (isKey || isTrioWheel) {
    return index + 1;
  }
  return index;
};

export const selectAllRunners = (
  position: number,
  wagerType: RaceWagerType,
  selections: string[][],
  dispatch: Dispatch,
  runners?: RunnerBI[]
) => {
  const { isKey } = wagerType;
  const positionSelections: string[] = [];
  const allSelections = [...selections];

  if (isKey && selections[0][0]) {
    runners?.forEach((runner: RunnerBI) => {
      if (
        !runner.isScratched &&
        runner.biNumber.toString() !== selections[0][0]
      ) {
        positionSelections.push(runner.biNumber.toString());
      }
    });
  } else {
    runners?.forEach((runner: RunnerBI) => {
      if (!runner.isScratched) {
        positionSelections.push(runner.biNumber.toString());
      }
    });
  }

  allSelections[position as number] = uniq(positionSelections);
  dispatch(setSelectionRequest(allSelections));
};

export const deselectAllRunners = (
  position: number,
  selections: string[][],
  dispatch: Dispatch
) => {
  const allSelections = [...selections];
  allSelections[position as number] = [];
  dispatch(setSelectionRequest(allSelections));
};
